import type { RouteObject } from 'react-router';
import { PageSites } from './PageSites.tsx';
import { PageNouveauSite } from './PageNouveauSite.tsx';
import { PageSite } from './PageSite.tsx';
import { PageEquipement } from './PageEquipement.tsx';

export const routesSites: RouteObject[] = [
  { path: 'sites', element: <PageSites /> },
  { path: 'sites/nouveau', element: <PageNouveauSite /> },
  { path: 'sites/:id', element: <PageSite /> },
  { path: 'sites/equipements/:id', element: <PageEquipement /> },
];
